import farmBG from './images/farmBG.png';
import illustration from './images/Illustration.png';
import profile from './images/profile.png';
import surveySidebarLG from './images/surveyFrameLG.png';
import surveySidebar from './images/surveyFrame.png';
import dataManagementBG from './images/datamanagementbox.png';

// icons
import logo from './icons/logo.svg';
import logoWhite from './icons/logoWhite.svg';
import searchIcon from './icons/search.svg';
import lockIcon from './icons/lock.svg';
import mailIcon from './icons/mail.svg';
import phoneIcon from './icons/phone.svg';
import employeeID from './icons/employeeID.svg';
import profileIcon from './icons/profile.svg';
import eyeClosed from './icons/eye-off.svg';
import eyeIcon from './icons/eye-show.svg';
import bellIcon from './icons/bell.svg';
import add from './icons/add.svg';
import editIcon from './icons/edit.svg';
import editOutline from './icons/editOutline.svg';
import editOutline2 from './icons/editOutline2.svg';
import editSurveyIcon from './icons/editSurveyIcon.svg';
import cross from './icons/cross.svg';
import invite from './icons/invite.svg';
import addBlock from './icons/add-block.svg';
import bulkUpload from './icons/bulk-upload.svg';
import calendar from './icons/calendar.svg';
import filter from './icons/filter.svg';
import prevIcon from './icons/prevIcon.svg';
import nextIcon from './icons/nextIcon.svg';
import firstPage from './icons/firstPage.svg';
import lastPage from './icons/lastPage.svg';
import saveIcon from './icons/save.svg';
import qrCode from './icons/qrCode.svg';
import qrIcon from './icons/qricon.svg';
import share from './icons/share.svg';
import download from './icons/download.svg';
import copyIcon from './icons/copy.svg';
import sendIcon from './icons/send.svg';
import uploadIcon from './icons/upload.svg';
import uploadFile from './icons/uploadFile.svg';
import sendOutline from './icons/sendOutline.svg';
import forwardIcon from './icons/forwardIcon.svg';
import forwardRed from './icons/forwardRed.svg';
import arrowIcon from './icons/arrow.svg';
import exportIcon from './icons/exportIcon.svg';
import chevronArrow from './icons/chevronArrow.svg';
import downloadRed from './icons/downloadRed.svg';
import deleteRedIcon from './icons/deleteRedIcon.svg';
import Trashred from './icons/Trashred.svg';
import editIconeTtp from './icons/editTtp.svg';
import geoLocation from './icons/gis_location.svg';

import editIconSurvey from './icons/edit-3.svg';

import addBoxIcon from './icons/addBox.svg';
import addPlusIcon from './icons/addPlus.svg';

import fullScreen from './icons/fullscreen.svg';

import uploadError from './icons/upload_error.svg';
import accordionIcon from './icons/accordianArrow.svg';

// Report Icon
import reportUserUnion from './icons/reportUserUnion.svg';
import reportUserVector from './icons/reportUserVector.svg';
import reportSubtract from './icons/reportSubtract.svg';
import reportDownload from './icons/downloadReport.svg';
import cancellationIcon from './icons/cancellationIconReport.svg';
import reportEventIcon from './icons/orderIconReport.svg';
import reportAttendance from './icons/reportAttendance.svg';
import reportSurvey from './icons/reportSurvey.svg';
import reportRateCycle from './icons/reportRateCycle.svg';
import surveyFillIcon from './icons/surveyFillIcon.svg';
import postSurveyIcon from './icons/postSurveyIcon.svg';
import farmerListIcon from './icons/farmerListIcon.svg';

// Dashboard Icon

import dashboard from './icons/dashboard.svg';
import event from './icons/event.svg';
import survey from './icons/survey.svg';
import training from './icons/training.svg';
import farmer from './icons/farmer.svg';
import newfarmer from './icons/newfarmer.svg';
import participants from './icons/participants.svg';
import approval from './icons/approval.svg';
import reportAnalyse from './icons/report-analyse.svg';
import verification from './icons/verification.svg';
import setting from './icons/setting.svg';
import logout from './icons/logout.svg';
import requests from './icons/requests.svg';
import organisation from './icons/organisation.svg';
import d_farm from './icons/farm.svg';
import male from './icons/male.svg';
import female from './icons/female.svg';

//T&V Icon
import compliance from './icons/compliance.svg';
import scoreCard from './icons/scoreCard.svg';
import tvfarmCloseColour from './icons/closewithcolor.svg';
import tvfarmClose from './icons/closewithoutcolor.svg';
import tvTick from './icons/tick.svg';
import tvEyeIcon from './icons/eyeIcon.svg';
import tvEyeIconRed from './icons/eyeIconRed.svg';

//CC
import memberPortalIcon from './icons/memberPortalIcon.svg';
import assessment from './icons/assessment.svg';

// Super Admin
import reportAdmin from './icons/reportAdmin.svg';
import trainingAdmin from './icons/trainingAdmin.svg';
import eventAdmin from './icons/eventAdmin.svg';
import onBoardingAdmin from './icons/onBoardingAdmin.svg';

// Input Fields Icons

import calendarInput from './icons/calendarInput.svg';
import deleteInput from './icons/DeleteInput.svg';
import deleteIcon from './icons/deleteIcon.svg';
import uploadInput from './icons/uploadInput.svg';
import EditIcon from './icons/EditIcon.svg';
import timeiconinput from './icons/timeinput.svg';

//button icons

import plusbutton from './icons/plusbutton.svg';
import trainingdelete from './icons/trainingdelete.svg';
import trainingedit from './icons/trainingedit.svg';
import shareicon from './icons/shareicon.svg';
import uploadcolor from './icons/uploadcolor.svg';
import twopeople from './icons/twopeople.svg';
import acceptattendance from './icons/acceptattendance.svg';
import rejectattendance from './icons/rejectattendance.svg';

import crossIcon from './icons/crossIcon.svg';
import squareButtons from './icons/squareButtons.svg';

//Logos

import plusLogo from './icons/pluslogo.svg';
import plusIcon from './icons/plusIcon.svg';

//player icon

import iconplay from './icons/iconplay.svg';
import icondocument from './icons/documentsIcon.svg';
import usermanagement from './icons/usermanagement.svg';
import arrowCircle from './icons/arrowCircle.svg';
import farmarLocation from './icons/farmarLocation.svg';
import totalParticipants from './icons/totalParticipants.svg';
import events from './icons/events.svg';

import penEdit from './icons/penEdit.svg';
import shareArrow from './icons/shareArrow.svg';
import clock from './icons/clock.svg';
import mapPin from './icons/map-pin.svg';
import calIcon from './icons/calendarIcon.svg';
import home from './icons/home.svg';

export const Images = {
  logo,
  logoWhite,
  farmBG,
  illustration,
  profile,
  surveySidebar,
  surveySidebarLG,
  dataManagementBG,
};

export const Icons = {
  accordionIcon,
  searchIcon,
  lockIcon,
  mailIcon,
  phoneIcon,
  employeeID,
  profileIcon,
  eyeIcon,
  eyeClosed,
  bellIcon,
  editIcon,
  add,
  cross,
  invite,
  filter,
  calendar,
  prevIcon,
  nextIcon,
  firstPage,
  lastPage,
  saveIcon,
  bulkUpload,
  addBlock,
  qrCode,
  download,
  share,
  copyIcon,
  sendIcon,
  uploadIcon,
  uploadFile,
  sendOutline,
  forwardIcon,
  forwardRed,
  arrowIcon,
  exportIcon,
  chevronArrow,
  geoLocation,
  qrIcon,
  editSurveyIcon,
  downloadRed,
  deleteRedIcon,
  Trashred,
  editIconeTtp,
  editIconSurvey,
  fullScreen,

  reportDownload,
  cancellationIcon,
  reportEventIcon,
  reportAttendance,
  reportSurvey,
  reportRateCycle,
  surveyFillIcon,
  postSurveyIcon,
  farmerListIcon,
  addPlusIcon,
  addBoxIcon,
  uploadError,

  // Dashboard Icon

  dashboard,
  event,
  survey,
  training,
  farmer,
  newfarmer,
  approval,
  participants,
  reportAnalyse,
  setting,
  logout,
  verification,
  requests,
  organisation,
  d_farm,
  male,
  female,

  //T&V Icon
  compliance,
  scoreCard,
  tvfarmCloseColour,
  tvfarmClose,
  tvTick,
  tvEyeIcon,
  tvEyeIconRed,

  //CC
  memberPortalIcon,
  assessment,

  // SuperAdmin Icon
  reportAdmin,
  trainingAdmin,
  eventAdmin,
  onBoardingAdmin,

  //Input icons
  calendarInput,
  deleteInput,
  deleteIcon,
  uploadInput,
  EditIcon,
  timeiconinput,
  editOutline,
  editOutline2,

  //button icons
  plusbutton,
  trainingdelete,
  trainingedit,
  shareicon,
  uploadcolor,
  twopeople,
  plusIcon,
  squareButtons,
  crossIcon,

  //plus logo
  plusLogo,

  //player icon
  iconplay,
  icondocument,

  //attendance
  acceptattendance,
  rejectattendance,

  // report analytics
  reportUserUnion,
  reportUserVector,
  reportSubtract,

  usermanagement,
  arrowCircle,
  farmarLocation,
  totalParticipants,
  events,
  penEdit,
  shareArrow,
  clock,
  mapPin,
  calIcon,
  home,
};
